// validationUtils.ts
import { withFormik } from 'formik';
import * as Yup from 'yup';

// Define Yup validation schema
const validationSchema = Yup.object().shape({
    ratingCriteria: Yup.array().required('Rating Criteria is required'),
    taskId: Yup.string().required('Rating Criteria is required'),
});

// Define the enhancer with Formik and Yup
export const withFormikValidation = withFormik({
    mapPropsToValues: () => ({ ratingCriteria: '', taskId: '' }),
    validationSchema,
    validateOnMount: true,
    handleSubmit: () => { },
});
